import { useState } from "react";
import { _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import useModal, { MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ErrorList } from "../../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";

interface Props {
    onChange: Function;
}

interface FormProps {
    Year: number;
    Mnemonic: string;
    Month?: number;
    IDAccount?: number;
    Consecutive?: number;
    AccountIDSte?: string;
    IDProject?: number
}

export const ParentDocument = ({ onChange }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_DocumentFactory);
    const [form, setForm] = useState<FormProps>({
        Mnemonic: "FV",
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
    })
    const paginador = usePaginator();

    const getLista = () => {
        instance.getDocumentHeaderByMnemonic(form.Year, form.Month, form.IDAccount, form.Mnemonic, form.Consecutive, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                if (resp.List) {
                    resp.List.forEach(element => {
                        const document = element.DataBeanProperties;
                        document.RenderDocumento = `${document.Consecutive ? `${document.Mnemonic} - ${document.Consecutive}` : "N/A"}`;
                        document.RenderFactura = `${document.ParentConsecutive ? `${document.ParentMnemonic} - ${document.ParentConsecutive}` : "N/A"}`;
                    });
                }
                setLista(resp.List);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'Documento Remisión', property: 'RenderDocumento', visible: true },
        { title: 'Identificación', property: 'AccountNit', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
        { title: 'Factura', property: 'RenderFactura', visible: true },
        { title: 'Fecha Factura', property: 'ParentDate', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: bean.IDDocument, evento: () => { getDocument(bean.IDDocument, bean.DocumentDate) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const modalDoc = useModal("Documento Contable", MODAL_XL);
    const [msgList, setMsgList] = useState<any>([]);
    const doc = useDataBean(_DocumentFactory)

    const getDocument = (idDocument: number, docDate: any) => {
        instance.getAccountantDocumentByLocation(idDocument, docDate).then(
            (resp) => {
                doc.setLista(resp.DocumentURL)
                modalDoc.open()
                setMsgList(resp.MsgList);
            }
        ).catch(err => { toast.error(err) })
    }

    const setRowBean =(e:any)=>{
        setBean(e);
        onChange?.(e);
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <YearSelector onChange={(e) => { setForm({ ...form, Year: e }) }} value={form.Year} tittle="Vigencia" />
            </div>
            <div className="col-md-6">
                <SelectMonths idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
            </div>
            <div className="col-md-6">
                <AccountEditor idAccount={form.IDAccount} label="Tercero" onChange={(e) => { setForm({ ...form, IDAccount: e.IDAccount }) }} />
            </div>
            <div className="col-md-6">
                <label>Consecutivo</label>
                <input type="number" className="form-control" value={form.Consecutive} onChange={(e) => {
                    const value = e.target.value ? Number(e.target.value) : null;
                    setForm({ ...form, Consecutive: value })
                }} />
            </div>

            <div className="col-md-6 mt-4">
                <BasicButton eventClick={() => {
                    if (form.Year && form.Mnemonic) {
                        getLista();
                    }
                }} icon="ri-search-line" children={`Buscar`} />
            </div>
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setRowBean}
                    listButtons={listaBotones()}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                    <div className="row">
                        <div className="col">
                            {msgList.length > 0 &&
                                <ErrorList lista={msgList} />
                            }
                            {msgList.length === 0 && lista.length > 0 &&
                                <DocumentViewer key={doc.lista} list={doc.lista} />
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}